import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import DataTable from "react-data-table-component";
import SweetAlert from "react-bootstrap-sweetalert";
import Header from "../../../components/dashboard/header";
import Footer from "../../../components/dashboard/footer";
import SideMenu from "../../student/SideMenu";
import Loader from "../../../components/loader";
import SessionPopup from "../../SessionPopup";
import { contentContext } from "../../../context/contentContext";

let { lambda, appname } = window.app;

const STATUS_COLORS = {
    "Draft":                       { background: "#6c757d" },
    "Submitted":                   { background: "#0d6efd" },
    "Pending Payment":             { background: "#dc3545" },
    "Payment Received":            { background: "#198754" },
    "Under Lab Review":            { background: "#0dcaf0", color: "#000" },
    "Assigned to Pathologist":     { background: "#ffc107", color: "#000" },
    "Additional Test Requested":   { background: "#fd7e14" },
    "Additional Test In Progress": { background: "#6f42c1" },
    "Reassigned to Pathologist":   { background: "#20c997", color: "#000" },
    "Completed":                   { background: "#198754" },
    "Converted to Learning Case":  { background: "#0a58ca" },
};

export default function DoctorBiopsyList() {
    const navigate = useNavigate();
    const doctorId = localStorage.getItem("userId");
    const token = localStorage.getItem("token");

    const {
        isLoading, setIsLoading,
        data, setData,
        usersearch, setUserSearch,
        searchedFlag, setSearchedFlag,
        currentPageNew, setCurrentPage,
        rowsPerPage, setRowsPerPage,
        route, setRoute,
        usePrevious,
        GetTimeActivity,
    } = useContext(contentContext);

    const [showSessionPopup, setShowSessionPopup] = useState(false);
    const [tableError, setTableError] = useState(false);

    const prevRoute = usePrevious(route);
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute !== route) {
            setCurrentPage(1);
            setRowsPerPage(15);
            setSearchedFlag(false);
            setUserSearch("");
        }
    }, [prevRoute]);

    useEffect(() => {
        setRoute("biopsy");
        setData([]);
        if (!localStorage.getItem("token")) navigate("/");
    }, []);

    useEffect(() => {
        if (searchedFlag) {
            handleSearch();
        } else {
            fetchCases();
        }
    }, [searchedFlag]);

    const filterCreatedByMe = (rows) => (rows || []).filter((row) => row?.createdby === doctorId);

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const d = new Date(dateStr);
        const day   = d.toLocaleString("en-GB", { day: "2-digit",    timeZone: "Asia/Kolkata" });
        const month = d.toLocaleString("en-GB", { month: "2-digit",  timeZone: "Asia/Kolkata" });
        const year  = d.toLocaleString("en-GB", { year: "numeric",   timeZone: "Asia/Kolkata" });
        const time  = d.toLocaleString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true, timeZone: "Asia/Kolkata" });
        return `${day}-${month}-${year} ${time}`.toUpperCase();
    };

    const renderStatusBadge = (status) => {
        const s = status || "Submitted";
        const style = STATUS_COLORS[s] || { background: "#6c757d" };
        return (
            <span style={{
                ...style,
                color: style.color || "#fff",
                padding: "3px 8px",
                borderRadius: "4px",
                fontSize: "11px",
                fontWeight: "600",
                whiteSpace: "nowrap",
                display: "inline-block",
            }}>
                {s}
            </span>
        );
    };

    const columns = [
        {
            name: "Path Ref No",
            selector: (row) => row?.pathrefno ?? "",
            sortable: true,
        },
        {
            name: "Biopsy Date",
            selector: (row) => row?.biopsydate ?? "",
            sortable: true,
            cell: (row) => formatDate(row?.biopsydate),
        },
        {
            name: "Specimen Type",
            selector: (row) => row?.specimentype ?? "",
            sortable: true,
        },
        {
            name: "Site of Biopsy",
            selector: (row) => row?.siteofbiopsy ?? "",
            sortable: true,
        },
        {
            name: "Status",
            selector: (row) => row?.status ?? "",
            sortable: true,
            cell: (row) => renderStatusBadge(row?.status),
        },
        {
            name: "Created On",
            selector: (row) => row?.created ?? "",
            sortable: true,
            cell: (row) => formatDate(row?.created),
        },
        {
            name: "Actions",
            cell: (row) => (
                <div className="d-flex">
                    <a
                        onClick={() => handleViewCase(row.patientid)}
                        className="text-success action-button"
                        style={{ cursor: "pointer" }}
                    >
                        <i className="mdi mdi-eye font-size-18"></i>
                    </a>
                      {row?.status !== "Completed" && (
                        <a onClick={(e) => handleEditCase(e, row.patientid)}
                          className='text-danger action-button'

                          ><i
                              className="mdi mdi-pencil font-size-18"></i> </a>
                      )}
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const fetchCases = () => {
        setIsLoading(true);
        axios.get(`${lambda}/biopsyCaseInfo?appname=${appname}&token=${token}&createdby=${doctorId}`)
            .then((res) => {
                if (res?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopup(true);
                } else {
                    const result = filterCreatedByMe(res?.data?.result);
                    setData(result);
                    global.exportExcelData = result;
                }
                setIsLoading(false);
                setUserSearch("");
                setSearchedFlag(false);
            })
            .catch(() => {
                setTableError(true);
                setIsLoading(false);
            });
    };

    const handleSearch = () => {
        GetTimeActivity();
        if (!usersearch) {
            fetchCases();
            return;
        }
        setIsLoading(true);
        axios.get(`${lambda}/biopsyCaseInfo?appname=${appname}&token=${token}&createdby=${doctorId}&search=${usersearch}`)
            .then((res) => {
                if (res?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopup(true);
                } else {
                    const result = res?.data?.result || [];
                    setData(result);
                    global.exportExcelData = result;
                }
                setIsLoading(false);
            })
            .catch(() => {
                setTableError(true);
                setIsLoading(false);
            });
    };

    const handleSearchInput = (e) => {
        if (e.target.value === "") setSearchedFlag(false);
        setUserSearch(e.target.value);
    };

    const handleSearchSubmit = () => {
        GetTimeActivity();
        setCurrentPage(1);
        setSearchedFlag(true);
        handleSearch();
    };

    const handleSearchKeyPress = (e) => {
        if (e.key === "Enter") {
            GetTimeActivity();
            setTimeout(handleSearch, 500);
        }
    };

    const handleClearSearch = () => {
        GetTimeActivity();
        setUserSearch("");
        setSearchedFlag(false);
        fetchCases();
        setCurrentPage(1);
    };

    const handleViewCase = (patientId) => {
        GetTimeActivity();
        navigate(`/biopsy/cases/${patientId}`);
    };
       const handleEditCase = (e, patientId) => {
        GetTimeActivity();
        navigate(`/biopsy/cases/${patientId}/edit`);
    };

    const customSort = (rows, selector, direction) => {
        const sorted = rows.slice().sort((a, b) => {
            const aVal = String(selector(a)).toLowerCase();
            const bVal = String(selector(b)).toLowerCase();
            const cmp = aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
            return direction === "desc" ? cmp * -1 : cmp;
        });
        global.exportExcelData = sorted;
        return sorted;
    };

    const noDataComponent = () => (
        <div className="empty-state-body empty-record">
            <div className="empty-state__message">
                <span className="material-icons">summarize</span>
                <p className="form-check font-size-16">No data were found</p>
            </div>
        </div>
    );

    return (
        <>
            {showSessionPopup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <SideMenu />
                <div className="main-content user-management" id="main-content">
                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="row mb-4 breadcrumb">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title">Biopsy Cases</h4>
                                        </div>
                                        <button className="create-quiz-btn border-0" onClick={() => navigate("/biopsy/cases/new")}>
                                            Create New Case
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="row table-data">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            {isLoading ? <Loader /> : (
                                                <>
                                                    <div className="row mb-2">
                                                        <div className="col-sm-8 ms-auto">
                                                            <div className="search-box mb-2 d-inline-block">
                                                                <div className="position-relative">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={usersearch}
                                                                        onChange={handleSearchInput}
                                                                        placeholder="Search"
                                                                        onKeyPress={handleSearchKeyPress}
                                                                    />
                                                                    <button className="fill_btn" onClick={handleSearchSubmit}>
                                                                        <span className="material-icons search-icon">search</span>
                                                                    </button>
                                                                </div>
                                                                <div className="dataTables_length">
                                                                    <button className="fill_btn" onClick={handleClearSearch}>
                                                                        <span className="material-icons-outlined">sync</span>Reset
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <DataTable
                                                        key={`${rowsPerPage}_${data?.length}`}
                                                        columns={columns}
                                                        keyField="_id"
                                                        data={data}
                                                        direction="auto"
                                                        highlightOnHover
                                                        pagination
                                                        responsive
                                                        persistTableHead
                                                        striped
                                                        subHeaderAlign="right"
                                                        noDataComponent={noDataComponent()}
                                                        paginationTotalRows={data?.length}
                                                        onChangeRowsPerPage={(n) => { GetTimeActivity(); setRowsPerPage(n); }}
                                                        onChangePage={(p) => { GetTimeActivity(); setCurrentPage(p); }}
                                                        paginationPerPage={rowsPerPage}
                                                        paginationDefaultPage={currentPageNew}
                                                        paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                        sortFunction={customSort}
                                                        paginationComponentOptions={{
                                                            rowsPerPageText: "Per page:",
                                                            rangeSeparatorText: "of",
                                                            noRowsPerPage: false,
                                                            selectAllRowsItem: false,
                                                        }}
                                                        progressPending={isLoading}
                                                        progressComponent={<Loader />}
                                                    />
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <SweetAlert
                        show={tableError}
                        custom
                        confirmBtnText="Ok"
                        confirmBtnBsStyle="primary"
                        title="Something went wrong. Please reload again."
                        onConfirm={() => setTableError(false)}
                    />

                    <Footer />
                </div>
            </div>
        </>
    );
}
